import React, {Fragment} from 'react';
import Link from 'react-router-dom/Link';
import { Row, Col, List, Avatar, Icon, Button } from 'antd';
import './UpdateSection.css';
import imgUpdate from '../../images/500/honeycomb-3143432_1920.jpg';

const data = [
  { 
    title: 'Opportunities for future growth could reach over $29 billion/year in the US alone',
    
  },
  {
    title: 'One study estimated telehealth had the potential to save $6 billion for employers',
  },
  {
    title: 'Over 400 million ambulatory-care visits per year in the US could be addressed with telemedicine.',
  },
  {
    title: 'An estimated 140+ million behavioral health doctor visits could be handled by telehealth appplications. ',
  },
];

const UpdateSection = (props) => {
   return (
      <Fragment>
      <div className="UpdateSection--container">
        
        <div className="UpdateSection--container-inner img-rounded">
          <div className="UpdateSection--headline">
            <h2> 
              <Icon type="rocket" style={{marginRight:15}}/> Social Media and New Updates
            </h2>
          </div>
          <Row>
            <Col sm ={24} md={8} style={{float:'left'}}>
              <Link to="/updates/">
              <div className="UpdateSection--image">
                <img className="UpdateSection--img-main img-responsive img-rounded" src={imgUpdate} alt="Press Releases and Social Media" />
              </div>
              </Link>
            </Col>
            <Col sm={24} md={16}>
              <div className="UpdateSection--description">
                <div className="UpdateSection--subheadline">
                Keep updated on the lastest trends with Real Time Touch social media and press releases.
                </div>
                <div className="UpdateSection--body-text">
      
                  <div className="UpdateSection--container-list">
                    <List 
                      itemLayout="horizontal"
                      dataSource={data}
                      renderItem={item => (
                        <List.Item>
                          <List.Item.Meta
                            avatar={<Avatar icon="rocket" />}
                            title={<span className="UpdateSection--list-item-headline">{item.title}</span>}
                            description=""
                          />
                        </List.Item>
                      )}
                    />
                  </div>
                </div>
              </div>            
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <div className="UpdateSection--button-moreinfo">
                <Link to="/updates/">
                  <Button size="large" type="default"><Icon type="rocket" style={{marginRight:5}}/>View More: Latest Headlines<Icon type="caret-right" /></Button>
                </Link>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      </Fragment>
    )
 }

 export default UpdateSection;


// WEBPACK FOOTER //
// ./src/containers/UpdateSection/UpdateSection.js